import { DesignRegistration } from "./designs";

export function designFamilyUrl(family: { reference: string }) {
    return `/designs/portfolio/family/${encodeURIComponent(family.reference)}`
}

export function designRegistrationUrl(registration: { reference: string }) {
    return `/designs/portfolio/registration/${encodeURIComponent(registration.reference)}`
}

export function isActiveDesign(registration: DesignRegistration) {
    // Active designs are those that are pending or registered
    // Stopped and in-preparation are considered inactive
    return registration.status === "pending" || registration.status === "registered"
}
